<template>
  <div class="gallery">
    <!-- modal for post delete -->
    <transition mode="out-in" name="fade">
      <image-modal @close="showModal = false" :mediaId="currentMediaId" v-if="showModal" />
    </transition>

    <div class="columns is-multiline" v-if="!media.hasOwnProperty('.value')">
      <template v-for="(img, key) in images" v-if="img.src && img.path">
        <div class="column is-narrow" :key="key">
          <a class="img-container">
            <div @click="deleteImage(img.path, key)" class="delete delete-button"></div>
            <div @click="showImage(key)">
              <MediaImage :imagePath="img.path" :thumbSize="480"></MediaImage>
            </div>
            <div class="info-tab"> {{img.name}} </div>
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import MediaImage from './MediaImage'
import ImageModal from '../../shared/ImageModal'

import { mediaRef } from '@/firebase_config'

export default {
  name: 'Media',
  data: function () {
    return {
      showModal: false,
      currentMediaId: null
    }
  },
  firebase: {
    // load settings as an object instead of array (default)
    media: {
      source: mediaRef,
      asObject: true
    }
  },
  computed: {
    images () {
      return this.media
    }
  },
  methods: {
    showImage (key) {
      this.currentMediaId = key
      this.showModal = true
    },
    deleteImage (path, key) {
      let storageRef = firebase.storage().ref(path)
      var that = this
      storageRef.delete().then(function () {
        that.$firebaseRefs.media.child(key).remove()
      }).catch(function (error) {
        console.error(error)
      })
    }
  },
  components: {
    MediaImage,
    ImageModal
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.gallery {
  margin: 16px;
}

.img-container {
  display: block;
  position: relative;
  width: 100%;
  padding-bottom: 100%;
  min-width: 280px;
}

.delete-button {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1;
}

.info-tab {
  position: absolute;
  bottom: 0px;
  height: 28px;
  width: 100%;
  padding: 4px;
  background-color: black;
  color: white;
  opacity: 0.71;
  z-index: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.image-div {
  position: absolute;
  width: 100%;
  height: 100%;
  background-size: cover;
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/content/Media.vue